import React, { Children } from 'react';
import { Carousel } from 'tradera/components/carousel/carousel';
import {
    LeftButton,
    RightButton
} from 'tradera/components/carousel/carousel-buttons';
import { CarouselContent } from 'tradera/components/carousel/carousel-content';
import useIsMobile from 'tradera/hooks/use-is-mobile';
import { useIsTablet } from 'tradera/hooks/use-is-tablet';

export const PopCatCarousel = ({ children, orientation }) => {
    const isMobile = useIsMobile();
    const isTablet = useIsTablet();

    const topPosition = orientation === 'Landscape' ? '9rem' : '17rem';

    const numberOfChildren = Children.count(children);
    // Why Math.min? If only two children on desktop, let those two span full
    // width instead of leaving the third slot empty.
    const numberCarouselCards = isMobile
        ? 1
        : isTablet
        ? Math.min(numberOfChildren, 2)
        : Math.min(numberOfChildren, 3);

    return (
        <Carousel
            id="pop-cat-carousel"
            numberItemsToShow={numberCarouselCards}
            numberItemsToScroll={numberCarouselCards}
            showScrollbar={isMobile}
            className="mx-0 mx-md-3 mx-lg-2 mx-xl-0">
            <LeftButton size="md" style={{ top: topPosition }} />
            <CarouselContent>{children}</CarouselContent>
            <RightButton size="md" style={{ top: topPosition }} />
        </Carousel>
    );
};
